import React, { useState, useEffect } from "react";
import moment from "moment";

interface IPropsType {
    menu: Array<{ Name: string, Text: string, Data: any, isActive: boolean }>,
}

function Tabs(props: IPropsType) {

    const [activeTab, setActiveTab] = useState(props.menu[0]);

    const Menu = () => {
        return (            
            <div className="menuButtons">
                {props.menu.map((item) => {
                    return (
                        <h4
                            className={activeTab.Name == item.Name ? 'active' : ''}
                            onClick={() => { setActiveTab(item) }}>
                            {item.Text}
                        </h4>
                    )
                })}
                </div>);
    }

    return (
        <div>
            { Menu() }
            {/* активная вкладка */}
            {activeTab.Data}
        </div>
    )
}


export default Tabs;